// extracted by mini-css-extract-plugin
module.exports = {"OtzivMapHeader":"otzivMap-module--OtzivMapHeader--1Rb_y","OtzivMapText":"otzivMap-module--OtzivMapText--2z19m","OtzivMapBox":"otzivMap-module--OtzivMapBox--P--NN"};